/** The longest in-app path accepted from outside (a notification, a link). */
const MAX_PATH_LENGTH = 2048;

/**
 * An in-app path from outside the app (the mobile shell: a notification tap, a link), or null.
 * One leading slash (a double slash is protocol-relative, i.e. another site), no whitespace or
 * backslash. Same rule as the shell's own check, so a request is vetted on both sides.
 */
export function inAppPath(value: unknown): string | null {
  if (typeof value !== 'string' || value.length === 0 || value.length > MAX_PATH_LENGTH) {
    return null;
  }
  return /^\/(?!\/)[^\s\\]*$/.test(value) ? value : null;
}
